/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dateRangeSchema = z.object({
  from: z.iso.date(),
  to: z.iso.date(),
});
